<div class="az-selector">
  <label class="az-selector__label" *ngIf="label">{{ label }}</label>

  <div class="az-selector__control" (click)="toggleDropdown()">
    <span class="az-selector__selected">{{ selectedValue || 'Select an option' }}</span>
    <div class="az-selector__arrow-container">
      <span class="material-symbols-outlined az-selector__arrow" aria-hidden="true">
        {{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    </div>
  </div>

  <div class="az-selector__dropdown" *ngIf="isOpen">
    <div
      class="az-selector__option"
      *ngFor="let option of options"
      (click)="selectOption(option)"
      [class.az-selector__option--selected]="option === selectedValue"
    >
      {{ option }}
    </div>
  </div>
</div>
